<template>
  <div>
      <v-card class="mx-auto content-personal" max-width="95%" style="padding:30px; font-size: 14px;" :flat='true'>
        <!-- <div v-if="user_site_reg && user_site_reg.need_tour" class="date-interval d-flex">
          <p style="color: green; font-size: 16px; margin-top: 16px !important; padding-right: 10px !important;"><b>Вы записаны на экскурсию</b></p>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
                <v-icon
                small
                v-bind="attrs"
                v-on="on"
                @click="registration(false)">
                mdi-close-circle-outline
                </v-icon>
            </template>
            <span>отменить запись</span>
          </v-tooltip>
        </div>



        <div class="content-personal__header d-flex justify-space-between align-start" v-if="(user_site_reg && ( !user_site_reg.need_tour))">
          <v-chip
            class="mr-2 ml-2"
            dark
            outlined
            label
            style="margin-bottom:20px;"
            @click="registration_dialog = true"
            color="#ff810a">
            <v-icon left>mdi-check-decagram</v-icon>
              Записаться на экскурсию
          </v-chip>
        </div> -->





        <!-- <v-row>
          <h2 class="mt-2 ml-8" style="text-align: center;">Экскурсия в Национальном исследовательском центре «Курчатовский институт»</h2>
        </v-row> -->
        <v-row>
          <p class="mt-2 ml-4">Приглашаем гостей Курчатовского форума синхротронных и нейтронных исследований принять участие в экскурсии в НИЦ "курчатовский институт".</p>
          <!-- <p class="mt-2 ml-4">Приглашаем гостей Курчатовского форума синхротронных и нейтронных исследований принять участие в экскурсии 24 октября 2023 года.</p> -->
          <p class="ml-4">Вы познакомитесь с первым в Евразии ядерным реактором Ф-1 и Курчатовским специализированным источником синхротронного излучения "КИСИ-Курчатов".</p>
          <p class="ml-4">Реактор Ф-1 является памятником науки и техники Российской Федерации и мемориальным комплексом. 78 лет назад, 25 декабря 1946 г. в Лаборатории № 2 АН СССР (сейчас НИЦ "Курчатовский институт") под руководством И.В. Курчатова на нем была осуществлена самоподдерживающаяся ядерная цепная реакция.</p>
          <p class="ml-4">Курчатовский источник синхротронного излучения ("КИСИ-Курчатов") является единственным специализированным источником синхротронного излучения на постсоветском пространстве. "КИСИ - Курчатов" это   уникальная научная установка класса "мегасайенс", внесенная в федеральный реестр уникальных научных установок.</p>
          <p class="ml-4">Официальное открытие КИСИ состоялось 1 октября 1999 года, и с тех пор установка используется по 23 часа в сутки, 6 дней в неделю, с единственным крупным перерывом за год - на время летних каникул.</p>
          <p class="ml-4"></p>

        </v-row>
        <v-row class="pa-4">
          <v-img
            :src="kisi_pic"
            class="logo"
          ></v-img>
        </v-row>
      </v-card>


    <v-dialog v-model="registration_dialog" persistent max-width="40%">
      <v-card>
        <v-card-title class="headline">Записаться на экскурсию
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="registration_dialog = false">отмена</v-btn>
          <v-btn color="green darken-1" text
            @click="registration(true)">{{"Записаться"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>

import { mapActions, mapMutations } from 'vuex';
// import ir8_pic from '../../src/assets/ir8_pic.jfif';
import kisi_pic from '../../src/assets/kisi_pic.jpg';

export default {
  name: 'Orgs',
  data: () => ({
    user_site_reg: false,
    registration_dialog: false,
    // ir8_pic,
    kisi_pic,
  }),

  mounted() {
    // if(localStorage.isLoggedIn)
    //   this.uploadDataUser();

  },

  methods: {
    ...mapActions([
      'GET_USER_SITE_REG',
      'CHANGE_REGISTRATION',
    ]),
    ...mapMutations([
      'UPDATE_OVERLAY',
    ]),

    async uploadDataUser() {
      try {
        this.UPDATE_OVERLAY(true)
        const site_reg = await this.GET_USER_SITE_REG();
        if(site_reg.length > 0)
          this.user_site_reg = site_reg[0]

          this.UPDATE_OVERLAY(false)
      } catch (ex) {
        console.log('ex ---> ', ex);
      }
    },

    registration(val = true){
      if(this.user_site_reg && this.user_site_reg.id > 0){
        let dataUpdateStatus = {
          id: this.user_site_reg.id,
          need_tour: val,
          type: 'change_tour'
        };

        this.change_reg(dataUpdateStatus)
      }
      else{
        this.$messageHelper('Что-то пошло не так, попробуйте обновить страницу', 'error', 3000);
      }
    },

    change_reg(dataUpdateStatus){
      this.UPDATE_OVERLAY(true)

      this.CHANGE_REGISTRATION(dataUpdateStatus)
        .then((res) => {
          if (!res.data.hasOwnProperty('error')) {
            this.registration_dialog = false;
            this.uploadDataUser();
            this.$messageHelper('Успешнo', 'success', 3000);
          } else {
            this.$messageHelper(res.data.error, 'error', 3000);
          }
          this.UPDATE_OVERLAY(false)
        })
        .catch((e) => {
          console.log('eee', e);
          this.$messageHelper(e.message, 'error', 4000);
          this.UPDATE_OVERLAY(false)
        });
      },
  },
  
};
</script>
<style lang="scss" scoped>
  .content-personal{
    -webkit-box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;
    background-color: #fff;
    border-radius: 13px!important;
}
.theme--light.v-application {
    background: rgb(248, 248, 248) !important;
    color: rgba(0, 0, 0, 0.87);
}

.date-interval {
    margin-bottom: 0 !important;
    display: none !important;
}

@media screen and (max-width:767px) {
  .content-personal {
    max-width: 90% !important;
  }
  .content-personal__header {
    flex-direction: column;
  }
}
</style>
